import { motion } from 'framer-motion';
import { useInView } from 'framer-motion';
import { useRef } from 'react';
import { ArrowRight } from 'lucide-react';

const Collection = () => {
  const ref = useRef(null);
  const isInView = useInView(ref, { once: true, margin: '-100px' });

  // Featured watches (2 principais em destaque)
  const featuredWatches = [
    {
      title: 'Seiko 5 Sports GMT',
      image: 'https://customer-assets.emergentagent.com/job_horological-craft/artifacts/4dczrpo0_Captura%20de%20Tela%202026-03-31%20a%CC%80s%2022.36.40.png'
    },
    {
      title: 'Omega Speedmaster',
      image: 'https://customer-assets.emergentagent.com/job_horological-craft/artifacts/6c3ukj7j_Captura%20de%20Tela%202026-03-31%20a%CC%80s%2022.38.21.png'
    }
  ];

  // Regular watches (11 relógios)
  const watches = [
    {
      title: 'Seiko 5 Sports GMT',
      image: 'https://customer-assets.emergentagent.com/job_horological-craft/artifacts/n3ctpvns_Captura%20de%20Tela%202026-03-31%20a%CC%80s%2022.38.30.png'
    },
    {
      title: 'Seiko Presage 60s Style',
      image: 'https://customer-assets.emergentagent.com/job_horological-craft/artifacts/sagr2ws9_Captura%20de%20Tela%202026-03-31%20a%CC%80s%2022.37.45.png'
    },
    {
      title: 'Seiko Presage 60s Style',
      image: 'https://customer-assets.emergentagent.com/job_horological-craft/artifacts/428eapsj_Captura%20de%20Tela%202026-03-31%20a%CC%80s%2022.37.37.png'
    },
    {
      title: 'Seiko Prospex Alpinist 39mm',
      image: 'https://customer-assets.emergentagent.com/job_horological-craft/artifacts/7qat5svt_Captura%20de%20Tela%202026-03-31%20a%CC%80s%2022.36.55.png'
    },
    {
      title: 'Heuer Airline GMT quartz 36mm (1983)',
      image: 'https://customer-assets.emergentagent.com/job_horological-craft/artifacts/xp8r457a_WhatsApp%20Image%202026-04-04%20at%2009.08.31%20%281%29.jpeg'
    },
    {
      title: 'Tag Heuer 6000. WH1153. Ouro 18k. 38mm',
      image: 'https://customer-assets.emergentagent.com/job_horological-craft/artifacts/xrjhwa0x_WhatsApp%20Image%202026-04-04%20at%2009.08.31.jpeg'
    },
    {
      title: 'Seiko 5 sports, automático SRPE 53 40mm',
      image: 'https://customer-assets.emergentagent.com/job_horological-craft/artifacts/ifogkp5d_WhatsApp%20Image%202026-04-13%20at%2011.21.08%20%281%29.jpeg'
    },
    {
      title: 'Seiko 5 Sports SRPH33 39mm',
      image: 'https://customer-assets.emergentagent.com/job_horological-craft/artifacts/45rpbaqw_WhatsApp%20Image%202026-04-13%20at%2011.21.08%20%282%29.jpeg'
    },
    {
      title: 'Seiko 5 sports edição limitada SRPK71',
      image: 'https://customer-assets.emergentagent.com/job_horological-craft/artifacts/cv896m23_WhatsApp%20Image%202026-04-13%20at%2011.21.08.jpeg'
    },
    {
      title: 'Seiko Recraft Series SNKP23',
      image: 'https://customer-assets.emergentagent.com/job_horological-craft/artifacts/hsmqfz2w_WhatsApp%20Image%202026-04-13%20at%2011.21.09%20%281%29.jpeg'
    },
    {
      title: 'Seiko 5 Sports Reduced 38mm SRPK29',
      image: 'https://customer-assets.emergentagent.com/job_horological-craft/artifacts/cy285swv_WhatsApp%20Image%202026-04-13%20at%2011.21.09.jpeg'
    }
  ];

  const instagramUrl = 'https://www.instagram.com/arttimewatches/';

  return (
    <section
      id="colecao"
      ref={ref}
      className="py-24 md:py-32 px-6 md:px-12 max-w-7xl mx-auto"
      data-testid="collection-section"
    >
      <motion.div
        className="text-center mb-16"
        initial={{ opacity: 0, y: 50 }}
        animate={isInView ? { opacity: 1, y: 0 } : { opacity: 0, y: 50 }}
        transition={{ duration: 0.8 }}
      >
        <div className="uppercase text-[#C9A646] font-sans text-xs md:text-sm tracking-[0.3em] mb-6">
          Coleção Exclusiva
        </div>
        <h2 className="font-serif text-3xl md:text-5xl text-white tracking-tight mb-4">
          Obras-Primas Disponíveis
        </h2>
        <p className="font-sans text-base md:text-lg text-[#A3A3A3] max-w-2xl mx-auto">
          Cada peça é selecionada com rigor para garantir autenticidade e excelência.
        </p>
      </motion.div>

      {/* Featured Watches - 3 em destaque maior */}
      <div className="mb-16">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 md:gap-12">
          {featuredWatches.map((watch, index) => (
            <motion.div
              key={index}
              className="group"
              initial={{ opacity: 0, y: 50 }}
              animate={isInView ? { opacity: 1, y: 0 } : { opacity: 0, y: 50 }}
              transition={{ duration: 0.8, delay: index * 0.2 }}
              data-testid={`featured-watch-${index}`}
            >
              <div className="relative overflow-hidden mb-6 aspect-square">
                <img
                  src={watch.image}
                  alt={watch.title}
                  className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-110"
                />
                <div className="absolute inset-0 bg-black/20 group-hover:bg-black/40 transition-colors duration-500"></div>
              </div>
              
              <h3 className="font-serif text-xl text-white mb-4">{watch.title}</h3>
              
              <a
                href={instagramUrl}
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center gap-2 text-[#C9A646] hover:text-white transition-colors duration-300 font-sans text-sm uppercase tracking-wider group"
                data-testid={`featured-watch-cta-${index}`}
              >
                Solicitar Detalhes
                <ArrowRight size={16} className="group-hover:translate-x-1 transition-transform" />
              </a>
            </motion.div>
          ))}
        </div>
      </div>

      {/* Regular Watches Grid - 7 relógios restantes */}
      <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6 md:gap-8">
        {watches.map((watch, index) => (
          <motion.div
            key={index}
            className="group"
            initial={{ opacity: 0, y: 50 }}
            animate={isInView ? { opacity: 1, y: 0 } : { opacity: 0, y: 50 }}
            transition={{ duration: 0.8, delay: (index + 3) * 0.15 }}
            data-testid={`watch-${index}`}
          >
            <div className="relative overflow-hidden mb-4 aspect-square">
              <img
                src={watch.image}
                alt={watch.title}
                className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-110"
              />
              <div className="absolute inset-0 bg-black/20 group-hover:bg-black/40 transition-colors duration-500"></div>
            </div>
            
            <h3 className="font-serif text-lg text-white mb-3">{watch.title}</h3>
            
            <a
              href={instagramUrl}
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-2 text-[#C9A646] hover:text-white transition-colors duration-300 font-sans text-xs uppercase tracking-wider group"
              data-testid={`watch-cta-${index}`}
            >
              Detalhes
              <ArrowRight size={14} className="group-hover:translate-x-1 transition-transform" />
            </a>
          </motion.div>
        ))}
      </div>
    </section>
  );
};

export default Collection;
